import React from 'react'

const Version = () => {
  return <div>{import.meta.env.VITE_VERSION}</div>
}

export default Version
